import React from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { Building, Package, Truck, FileCheck } from 'lucide-react';

export const MobileVendorPortal: React.FC = () => {
  return (
    <div className="p-4 space-y-4">
      <div className="text-center mb-6">
        <h1 className="text-2xl font-bold text-foreground mb-2">Vendor Portal</h1>
        <p className="text-muted-foreground">Manage vendor relationships and orders</p>
      </div>

      <div className="grid grid-cols-2 gap-4">
        <Card className="bg-card/50 border-border hover:bg-card/70 transition-colors">
          <CardContent className="p-4 text-center">
            <Building className="h-8 w-8 mx-auto mb-2 text-primary" />
            <p className="text-sm text-foreground font-medium">Vendors</p>
          </CardContent>
        </Card>

        <Card className="bg-card/50 border-border hover:bg-card/70 transition-colors">
          <CardContent className="p-4 text-center">
            <Package className="h-8 w-8 mx-auto mb-2 text-primary" />
            <p className="text-sm text-foreground font-medium">Orders</p>
          </CardContent>
        </Card>

        <Card className="bg-card/50 border-border hover:bg-card/70 transition-colors">
          <CardContent className="p-4 text-center">
            <Truck className="h-8 w-8 mx-auto mb-2 text-primary" />
            <p className="text-sm text-foreground font-medium">Deliveries</p>
          </CardContent>
        </Card>

        <Card className="bg-card/50 border-border hover:bg-card/70 transition-colors">
          <CardContent className="p-4 text-center">
            <FileCheck className="h-8 w-8 mx-auto mb-2 text-primary" />
            <p className="text-sm text-foreground font-medium">Contracts</p>
          </CardContent>
        </Card>
      </div>

      <div className="mt-6">
        <Card className="bg-card/30 border-border">
          <CardHeader>
            <CardTitle className="text-foreground text-lg">Pending Orders</CardTitle>
          </CardHeader>
          <CardContent>
            <p className="text-muted-foreground text-sm">No pending orders to display</p>
          </CardContent>
        </Card>
      </div>
    </div>
  );
};